import React from "react";
import { useTranslation } from "react-i18next";
import { Container, Accordion } from "react-bootstrap";
import '../CustomAccordion.css'
import SubstitutionTable from "../../../../components/RebarCpOtherInfoTables/SubstitutionTable";
import WasteTable from "../../../../components/RebarCpOtherInfoTables/WasteTable";
import PreCutRebarTable from "../../../../components/RebarCpOtherInfoTables/PreCutRebarTable";

const RebarCpOtherInfo = () => {
    const { t } = useTranslation();

    return (
        <Container fluid className='border border-top-0 p-3' style={{ backgroundColor: 'white' }}>
            <Accordion
                defaultActiveKey={["substitutions", "wastes", "precutRebars"]}
                alwaysOpen
            >
                <Accordion.Item eventKey="precutRebars">
                    <Accordion.Header>
                        <h5 className="text-center my-2">{t("Hazır Kesimli Donatı Listesi")}</h5>
                    </Accordion.Header>
                    <Accordion.Body>
                        <PreCutRebarTable
                            showDisableButtons={true}
                        />
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="substitutions" >
                    <Accordion.Header style={{ backgroundColor: 'white' }}>
                        <h5 className="text-center my-2">{t("Yerine Kullanım Listesi")}</h5>
                    </Accordion.Header>
                    <Accordion.Body>
                        <SubstitutionTable/>
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="wastes">
                    <Accordion.Header>
                        <h5 className="text-center my-2">{t("Fire Listesi")}</h5>
                    </Accordion.Header>
                    <Accordion.Body>
                        <WasteTable/>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

        </Container>
    )
}

export default RebarCpOtherInfo;